<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="groupsData"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="configure">
        <Button
          type="info"
          size="small"
          @click="resourcePermission(row)"
          v-hasPermission="[
            'permissionsConfigurationManagement:group:resource_Permission'
          ]"
          >{{
            $t("permission_configuration_management.group.configPermission")
          }}</Button
        >
      </template>
      <!-- 删除 -->
      <template slot-scope="{ row, index }" slot="delete">
        <Button
          type="success"
          size="small"
          v-hasPermission="['permissionsConfigurationManagement:group:log']"
          @click="logClick(row)"
          >{{
            $t("permission_configuration_management.common.operationLog")
          }}</Button
        >
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="groupsDelmodal = true"
            v-hasPermission="[
              'permissionsConfigurationManagement:group:delete'
            ]"
            >{{ $t("common.del") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <!-- 删除组模式框 -->
    <Modal v-model="groupsDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ groupsName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeGroup()"
          :disabled="isDisable"
        >
          {{ $t("common.del") }}
        </Button>
      </div>
    </Modal>
    <!-- 编辑组模式框 -->
    <Modal
      v-model="groupEditmodal"
      :title="$t('permission_configuration_management.group.editGroup')"
      :loading="loading"
      @on-ok="groupSubmit('groupEditForm')"
      @on-cancel="groupReset('groupEditForm')"
      :mask-closable="false"
      :okText="$t('permission_configuration_management.common.confirm')"
      :cancelText="$t('permission_configuration_management.common.cancel')"
    >
      <Form
        ref="groupEditForm"
        :model="groupEditForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 公司 -->
        <FormItem
          :label="$t('permission_configuration_management.account.company')"
          prop="companyId"
        >
          <div>{{ this.companyName }}</div>
        </FormItem>
        <!-- 组名称 -->
        <FormItem
          :label="$t('permission_configuration_management.group.groupName')"
          prop="name"
        >
          <Input
            v-model="groupEditForm.name"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>

        <!-- 备注 -->
        <FormItem
          :label="$t('permission_configuration_management.role.remark')"
          prop="remark"
        >
          <Input
            v-model="groupEditForm.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";

let tableGroupsVue = {};
export default {
  name: "TableGroups",
  components: {
    ConfigurationManagementOperationLog
  },
  data() {
    return {
      isShowOperationLog: false,
      companyName: "",
      val: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      groupsDelmodal: false,
      groupEditmodal: false,
      groupsName: "",
      modal_loading: false,
      isDisable: false,
      groupEditForm: {
        id: "",
        name: "",
        companyName: "",
        companyId: "",
        remark: ""
      },
      loading: true,
      columns: [
        {
          title: this.$t(
            "permission_configuration_management.group.companyName"
          ),
          key: "companyName"
        },
        {
          title: this.$t("permission_configuration_management.group.groupName"),
          key: "name",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    //编辑组弹出层
                    this.groupEditmodal = true;
                    this.groupEditForm.id = params.row.id;
                    // 组名称
                    this.groupEditForm.name = params.row.name;
                    // 公司ID
                    this.groupEditForm.companyId = params.row.companyId;
                    // 公司名称
                    this.companyName = params.row.companyName;
                    // 备注
                    this.groupEditForm.remark = params.row.remark;
                  }
                }
              },
              params.row.name
            );
          }
        },
        {
          title: this.$t("common.configure"),
          slot: "configure"
        },
        {
          title: this.$t("common.note"),
          key: "remark"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      groupsData: [],
      ruleValidate: {
        name: [
          { required: true, message: this.$t("permission_configuration_management.group.groupNameRequired"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("permission_configuration_management.group.groupNameLength"),
            pattern: "^.{4,20}$",
            trigger: "blur"
          }
        ]
      }
    };
  },
  beforeCreate: function() {
    tableGroupsVue = this;
  },
  mounted: function() {
    tableGroupsVue.getGroupsData();
  },
  methods: {
    showAll: function() {
      tableGroupsVue.getGroupsData();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.groupsName = this.groupsData[index].name;
    },
    // 点击资源权限跳转
    resourcePermission: function(row) {
      this.$router.push({
        path: "/permissionsConfigurationManagement/resourcePermission",
        query: { id: row.id }
      });
    },
    // 分页显示数据
    getGroupsData: function() {
      // 获取GroupSearch里面的搜索内容
      eventBus.$on("groupSearchName", function(val) {
        tableGroupsVue.val = val;
      });
      eventBus.$on("companyId", function(val) {
        tableGroupsVue.companyId = val;
      });
      //账户列表分页
      this.$api.group
        .pageGroup({
          companyId: tableGroupsVue.companyId,
          groupName: tableGroupsVue.val,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.groupsData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableGroupsVue.getGroupsData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableGroupsVue.getGroupsData();
    },
    // 删除
    removeGroup: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //账户删除
      this.$api.group
        .deleteGroup("id", this.groupsData[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableGroupsVue.getGroupsData();
            this.isDisable = false;
            this.modal_loading = false;
            this.groupsDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 销毁groupSearchName
    beforeDestroy: function() {
      eventBus.$off("groupSearchName");
    },
    // 编辑账户
    /*************************************************************************/
    // 确定
    groupSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          var editGroup = {
            id: this.groupEditForm.id,
            name: this.groupEditForm.name,
            remark: this.groupEditForm.remark
          };

          this.$api.group.updateGroup(editGroup).then(res => {
            setTimeout(() => {
              tableGroupsVue.getGroupsData();
              this.$refs[name].resetFields();
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.$Message.success(this.$t("common.editSuccess"));
              this.groupEditmodal = false;
            }, 1000);
          });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t("common.editFail"));
        }
      });
    },
    // 取消
    groupReset: function(name) {
      this.$refs[name].resetFields();
    },
    // 操作日志
    /****************************************************/
    logClick: function(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.id,
          10
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/group/TableGroups.vue